import React from 'react'
import { Router, Switch, Route, Redirect } from 'react-router-dom'
import LoginContainer from './containers/LoginContainer'
import DashboardContainerFrozen from './containers/DashboardContainerFrozen'
import { history } from './_helpers'
import { connect } from 'react-redux'
import { userActions } from './_actions'
import ResetPasswordContainer from './containers/ResetPasswordContainer'

function Routes(auth) {
  return (
    <Router history={history}>
      <Switch>
        <PrivateRoute path="/dashboard">
          <DashboardContainerFrozen />
        </PrivateRoute>
        <Route exact path="/">
          <LoginContainer />
        </Route>
        <Route exact path="/login">
          <LoginContainer />
        </Route>
        <Route exact path={'/reset-password/:token'}>
          <ResetPasswordContainer />
        </Route>
      </Switch>
    </Router>
  )
}
const mapStateToProps = state => {
  return { auth: state.user ? state.user : null }
}

export default connect(mapStateToProps)(Routes)

function PrivateRoute({ children, ...rest }) {
  const authToken = userActions.getCurrentToken()
  return (
    <Route
      {...rest}
      render={({ location }) =>
        authToken ? (
          children
        ) : (
          <Redirect
            to={{
              pathname: '/login',
              state: { from: location }
            }}
          />
        )
      }
    />
  )
}
